import { Facebook, Mail, Phone } from "lucide-react";
import { PageFrame } from "../components/PageFrame";
import { Reveal } from "../components/Reveal";
import { contact } from "../content/siteContent";

export function ContactPage() {
  return (
    <PageFrame
      className="contact-page"
      label="ΑΣΟ ΩΜΕΓΑ"
      title="Επικοινωνία"
      intro={<p>Επικοινωνήστε μαζί μας μέσω Facebook, email ή τηλεφώνου.</p>}
    >
      <Reveal className="contact-list technical-frame">
        <a href={contact.facebook} target="_blank" rel="noreferrer" data-target>
          <Facebook aria-hidden="true" />
          <span>
            <small>Facebook</small>
            {contact.facebook}
          </span>
        </a>
        <a href={`mailto:${contact.email}`} data-target>
          <Mail aria-hidden="true" />
          <span>
            <small>Email</small>
            {contact.email}
          </span>
        </a>
        <a href={`tel:${contact.phone.replace(/\s/g, "")}`} data-target>
          <Phone aria-hidden="true" />
          <span>
            <small>Τηλέφωνο</small>
            {contact.phone}
          </span>
        </a>
      </Reveal>
    </PageFrame>
  );
}
